export default "__VITE_ASSET__CilEku_I__"